<template>
    <el-container style="margin-top: -20px">
        <el-aside width="200px">
            <p style="display: flex; justify-content: center">
                <img src="../assets/logo2.png" style="width: 18px;height: 18px;margin-right: 2px">
                <span style="">特检通系统</span></p>
            <LCAside>
            </LCAside>
        </el-aside>
        <el-container>
            <el-header style="text-align: right; font-size: 12px;">
                <LCHearder></LCHearder>
            </el-header>
            <el-main :class="key=='/home'?'main':''" style="  ">
                <router-view :key="key"  ></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import LCAside from "@/components/LCAside";
    import LCHearder from "@/components/LCHearder";


    export default {
        name: "LCMain",
        components: {
            LCAside,
            LCHearder
        },
      computed: {
        key: function(){
          console.log(this.$router.fullPath);
          return this.$route.fullPath;
        }

      },
      // data(){
      //     return{
      //       // key:this.$router.fullPath
      //     }
      // }
    }
</script>

<style scoped>
.main{
    /*background-image: url("../assets/首页背景图.jpeg");*/
    /*background-size: cover;*/
    /*width: 100%;*/
    /*height: 100vh;*/
}
</style>